module.exports = __webpack_public_path__ + "static/img/cop_sch_logo16.59db1948.png";